import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import PracticeCard from './PracticeCard';
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json'
import { useLocation } from "react-router";


import batchImg from '../../assets/images/practics-banner.png';
import { cx } from '@emotion/css';
import * as styles from './practice.style.js';

function PracticeScreen(props) {
  const [events, set_events] = useState([]);
  const [loadedevents, set_loadedevents] = useState(false);

  let data1 = useLocation();

  function importAll(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  }

  const loadEvents = () => {
    const category = data1.state["category"];
    const level = data1.state["level"];
    const premiumlevel = data1.state["premiumlevel"];

    const quizes = importAll(require.context("./resources/", true, /\.(json)$/));
    const keys = Object.keys(quizes);
    let serialnumber = 0;
    const data12 = [];
    let time = 120;

    if (category === "SpellBowl") {
      time = 10;
    }

    for (let i = 0; i < keys.length; i++) {
      if (keys[i].includes(category) && keys[i].includes('Grade' + level)) {
        if (keys[i].includes("premium")) {
          const premiumlabel = keys[i].substring(keys[i].indexOf('premium'), keys[i].lastIndexOf('/'));
          const premiumnumber = premiumlabel.split("premium")[1];

          if (premiumnumber <= premiumlevel) {
            serialnumber += 1;
            const filename = keys[i].replace(/^.*[\\\/]/, '');
            const name = filename.substring(0, filename.length - 5);

            const json_object = {
              completed: 0,
              eventtype: 'Practice',
              evenstartdate: '2020-0-31',
              levels: ['Grade' + level],
              category: category,
              totalquestions: quizes[keys[i]].questions.length,
              level: 'Grade' + level,
              name: name,
              eventdisplay: '',
              qualificationno: quizes[keys[i]].questions.length - 1,
              time: time,
              questions: quizes[keys[i]].questions,
              id: serialnumber
            };

            data12.push(json_object);
          }
        }
      }
    }

    set_events(data12);
    set_loadedevents(true);
  };

  useEffect(() => {
    loadEvents();
    document.title = 'Practice';
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  let eventCards = events.map(event => {
    return (
      <div className='col-md-4' key={event.id}>
        <Col className="py-2 border rounded" key={event.id}>
          <PracticeCard
            imgsrc={"../assets/" + event.name + ".png"}
            title={event.name}
            key={event.id}
            levels={event.levels}
            totalquestions={event.totalquestions}
            event={event}
            category={data1.state}
          />
        </Col>
      </div>
    );
  });

  return (
    <div>
      {loadedevents ? (
        <div>
          <div className={cx(styles.batchBanner)}>
            <img src={batchImg} alt="" />

          </div>
          <div className={cx(styles.batchTitle)}>Let's Practice Cool Stuff</div>

          {data1.state["category"].includes("SpellBowl") ? (
            <div className={cx(styles.spellbowllicense)}>
              All Word Lists utilized herein have been provided by the Indiana Association of School Principals, Inc.
            </div>
          ) : null}

          <div className={cx(styles.allPracticeFluid)}>
            <Row>{eventCards}</Row>
          </div>
        </div>
      ) : (
        <div className="welcomecenter">
          <Lottie options={defaultOptions} height={400} width={400} />
        </div>
      )}
    </div>
  );
}

export default PracticeScreen;